<template>
  <svg class="logo" viewBox="0 0 50 45" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M49.3478 23.9182C39.087 42.0847 21.0145 45.1421 13.2609 44.4L15.8696 40.3927C22.4783 40.7489 27.029 39.2054 28.4783 38.3891L28.0435 36.608C24.0435 38.9234 18.8406 38.7601 16.7391 38.3891L20 33.046H23.0435V33.7138L28.0435 32.6007V31.7102C28.7391 31.7102 33.8406 28.7418 36.3043 27.2576L42.8261 29.7065C44.0435 28.6379 45.3623 26.1445 45.8696 25.0313L42.8261 23.9182C49.087 9.66994 38.913 5.95946 33.0435 5.88525L33.6957 4.32684C48.6957 4.7721 48.2609 16.6456 45.8696 22.5824L49.3478 23.9182Z"
      fill="white"
    />
    <path
      d="M37.1739 25.4766L41.9565 27.2576L42.8261 25.4766L40.4348 24.5861C46.6956 11.9408 37.3913 8.33417 31.9565 8.11154L31.087 9.66994C43.7826 11.451 40.4348 20.9498 37.1739 25.4766Z"
      fill="white"
    />
    <path
      d="M34.7826 1.87793L35.2174 0.542154C39.3913 0.185947 43.4058 2.17477 44.7826 3.2137L45.2174 2.54582C47.1304 3.08013 49.2029 5.88525 50 7.22102L47.8261 8.5568C44.8696 3.39181 37.8985 1.95214 34.7826 1.87793Z"
      fill="white"
    />
    <path d="M0 15.9035H1.08696V23.9182H9.56522V22.5824H2.6087V14.3451H0V15.9035Z" fill="white" />
    <path
      d="M20 14.3451H11.087V15.9035H17.6087L11.087 22.5824V23.9182H20V22.5824H13.4783L20 15.9035V14.3451Z"
      fill="white"
    />
    <path
      d="M23.2609 19.6915V18.3525H29.7826V15.9035H23.2609L23.2592 18.3525V19.4656L23.2609 23.9182H21.9565V14.3451H31.087V19.6915H23.2609Z"
      fill="white"
    />
  </svg>
</template>
